import React from "react";
import "@/index.css";
import { Toaster } from "@/components/ui/sonner";

// All components loaded immediately for instant display
import AudioPlayer from "@/components/AudioPlayer";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import AboutSection from "@/components/AboutSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      {/* Audio Player with welcome prompt */}
      <AudioPlayer />
      
      {/* Navigation */}
      <Navigation />
      
      {/* Main Content */}
      <main>
        <HeroSection />
        <AboutSection />
        <ContactSection />
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Floating WhatsApp Button */}
      <FloatingWhatsApp />
      
      {/* Toast notifications */}
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'hsl(0 0% 6%)',
            border: '1px solid hsl(43 74% 49% / 0.2)',
            color: 'hsl(47 100% 94%)',
          },
        }}
      />
    </div>
  );
}

export default App;
